import { FC } from 'react';

import { useNavigate } from 'react-router';

import {
  useAdjustCssForHeadless,
  useDocument,
  useDocumentErrorListener,
  useDocumentParams,
  useWindowScrollEvents,
} from '@/utils/document-utils';

import LoadingOverlay from '@/components/LoadingOverlay/LoadingOverlay';
import ChooseDocumentModal from '@/components/popups/ChooseDocumentModal';

import { XpApiError } from '@/services/api-types';

import Document from './Document';
import DocumentError from './DocumentError';

import { useBackUrl } from '@/atoms/document';

const SignalDocument: FC = () => {
  const navigate = useNavigate();
  const [backUrl] = useBackUrl();
  const { documentId } = useDocumentParams();
  const { icon, chooseReference, error, isFetching } = useDocument(
    documentId,
    false,
  );
  useWindowScrollEvents();
  useAdjustCssForHeadless();

  const otherError = useDocumentErrorListener();
  const otherErrorObject =
    typeof otherError === 'object' && otherError !== null
      ? otherError
      : undefined;

  if (error) {
    return (
      <DocumentError
        documentId={documentId}
        error={error as unknown as XpApiError}
        otherError={otherErrorObject}
      />
    );
  }

  return (
    <>
      {isFetching && <LoadingOverlay isOpen />}
      <ChooseDocumentModal
        icon={icon}
        isOpen={chooseReference.modalOpen}
        onClick={doc => chooseReference.selectReference(doc)}
        onClose={() => {
          if (backUrl) {
            navigate(backUrl);
            return;
          }
          navigate(-1);
        }}
        references={chooseReference.references}
      />
      <Document />
    </>
  );
};

export default SignalDocument;
